import { render } from "./PeoplePicker.vue?vue&type=template&id=7c6532c1&scoped=true"
import script from "./PeoplePicker.vue?vue&type=script&lang=js"
export * from "./PeoplePicker.vue?vue&type=script&lang=js"

import "./PeoplePicker.vue?vue&type=style&index=0&id=7c6532c1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6532c1"]])

export default __exports__